export default __webpack_public_path__ + "static/media/icn-arrow-open-focused.0495b2ab.svg";